import { SubmitButton as SubmitButtonType } from '@/schemas/sceneDataSchema';
import { ComponentButton } from './ComponentButton';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const SubmitButton = ({ component }: { component: SubmitButtonType }) => {
  const { trackClick } = useAnalytics();
  const handleClick = () => {
    trackClick(eventName(component.id), { button_type: component.type });
  };

  return (
    <ComponentButton
      form={component.form_id}
      component={component}
      type='submit'
      onClick={handleClick}
    />
  );
};
